
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const CodeLibraryPage = lazy(() => import('../pages/code-library/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/code-library',
    element: <CodeLibraryPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
